(function () {
  var popupSelector = '[role="dialog"][aria-label="POPUP Form"]';
  var klaviyoScrollLockClass = 'klaviyo-prevent-body-scrolling';
  var staleLockTimer = null;
  var watchedDialogs = [];
  var dialogObserver = null;
  var popupWasOpen = false;

  function dialogIsRendered(dialog) {
    if (
      !dialog.isConnected ||
      dialog.hidden ||
      dialog.getAttribute('aria-hidden') === 'true'
    ) {
      return false;
    }

    var style = window.getComputedStyle(dialog);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      dialog.getClientRects().length > 0
    );
  }

  function popupIsOpen() {
    return Array.prototype.some.call(
      document.querySelectorAll(popupSelector),
      dialogIsRendered
    );
  }

  function hasKlaviyoScrollLock() {
    return (
      (document.body && document.body.classList.contains(klaviyoScrollLockClass)) ||
      document.documentElement.classList.contains(klaviyoScrollLockClass)
    );
  }

  function cancelStaleLockCheck() {
    if (!staleLockTimer) return;
    window.clearTimeout(staleLockTimer);
    staleLockTimer = null;
  }

  function clearStaleKlaviyoLock() {
    staleLockTimer = null;
    if (popupIsOpen()) return;

    if (document.body) document.body.classList.remove(klaviyoScrollLockClass);
    document.documentElement.classList.remove(klaviyoScrollLockClass);
  }

  function scheduleStaleLockCheck() {
    if (!hasKlaviyoScrollLock() || popupIsOpen()) return;
    if (staleLockTimer) return;

    // Klaviyo can add its body lock before mounting or revealing the form.
    // Wait through that entrance race, then clear only an orphaned lock.
    staleLockTimer = window.setTimeout(clearStaleKlaviyoLock, 1500);
  }

  function sameDialogs(nextDialogs) {
    return (
      nextDialogs.length === watchedDialogs.length &&
      nextDialogs.every(function (dialog, index) {
        return dialog === watchedDialogs[index];
      })
    );
  }

  function watchCurrentDialogs() {
    var nextDialogs = Array.prototype.slice.call(
      document.querySelectorAll(popupSelector)
    );

    if (sameDialogs(nextDialogs)) return;

    if (dialogObserver) dialogObserver.disconnect();
    watchedDialogs = nextDialogs;

    if (!dialogObserver) return;
    watchedDialogs.forEach(function (dialog) {
      dialogObserver.observe(dialog, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'hidden', 'style', 'class']
      });
    });
  }

  function reconcilePopupState() {
    watchCurrentDialogs();

    var popupIsOpenNow = popupIsOpen();
    if (popupIsOpenNow) {
      cancelStaleLockCheck();
    } else if (popupWasOpen) {
      // A popup that was genuinely open has just closed or been removed.
      window.requestAnimationFrame(clearStaleKlaviyoLock);
    } else {
      scheduleStaleLockCheck();
    }

    popupWasOpen = popupIsOpenNow;
  }

  function nodeContainsPopup(node) {
    if (!node) return false;
    if (node.nodeType === 1 && node.matches(popupSelector)) return true;
    return typeof node.querySelector === 'function' && !!node.querySelector(popupSelector);
  }

  function mutationTouchesPopup(record) {
    return (
      Array.prototype.some.call(record.addedNodes, nodeContainsPopup) ||
      Array.prototype.some.call(record.removedNodes, nodeContainsPopup)
    );
  }

  function initialize() {
    if (!document.body) return;

    if (!('MutationObserver' in window)) {
      scheduleStaleLockCheck();
      return;
    }

    dialogObserver = new MutationObserver(reconcilePopupState);
    reconcilePopupState();

    var popupObserver = new MutationObserver(function (records) {
      if (records.some(mutationTouchesPopup)) reconcilePopupState();
    });

    popupObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    var lockObserver = new MutationObserver(reconcilePopupState);

    lockObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    lockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('pageshow', reconcilePopupState);
    document.addEventListener('click', function () {
      // Klaviyo normally closes synchronously, but some form animations hide
      // their wrapper just after the click has finished.
      window.setTimeout(reconcilePopupState, 0);
      window.setTimeout(reconcilePopupState, 400);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
